export class AppConstants {
    // App Constants
    public static USERID = 'USER_ID';
    public static TOKEN = 'token';
    public static CLIENT_CORRELATION_ID = 'CLIENT_CORRELATION_ID';
    public static PARTICIPATION_ID = 'PARTICIPATION_ID';
    public static GLOBAL_HEADER = 'GLOBAL_HEADER';
    public static GLOBAL_FOOTER = 'GLOBAL_FOOTER';
    public static UNIVERSITY_NAME = 'UNIVERSITY_NAME';
    public static PARTICIPATION_LABEL = 'PARTICIPATION_LABEL';
    public static DOB: any;
    public static CURRENT_NAV_TAB: any;

    // Status
    public static INVALID_STATUS = 'INVALID';
    public static FAILURE_STATUS = 'FAILURE';
    public static LOCKED_STATUS = 'LOCKED';
    public static SUCCESS_STATUS = 'SUCCESS';
    public static ERROR_STATUS = 'ERROR';
    public static INPUT_STATUS = 'REG_ERR_101';
    public static ROSTER_NOT_FOUND_STATUS = 'REG_ERR_102';
    public static REGISTRATION_ERROR_STATUS = 'REG_ERR_103';
    public static USER_EXISTS_STATUS = 'REG_ERR_104';
    public static SYSTEM_STATUS = 'REG_ERR_105';
    public static ENROLL_STATUS = 'REG_ERR_106';

    // Data Service
    public static LOGIN_FAILED = 'LOGIN_FAILED';
    public static REGISTRATION_FAILED = 'REGISTRATION_FAILED';
    public static FORGOT_PD_FAILED = 'SENDING_RESET_MAIL_FAILED';
    public static FORGOT_PD_SUCCESS = 'SENDING_RESET_MAIL_SUCCESS';
    public static RESET_PD_FAILED = 'RESET_PD_FAILED';
    public static RESET_PD_SUCCESS = 'RESET_PD_SUCCESS';
    public static HIDE_MENU = 'HIDE_MENU';
    public static DASHBOARD_FAILED = 'DASHBOARD_FAILED';
    public static WRONG_FILE_FORMAT = 'WRONG_FILE_FORMAT';
    public static SUCCESS = 'SUCCESS';
    public static UPDATE_MYDETAILS_SUCCESS = 'UPDATE_MYDETAILS_SUCCESS';
    // For Dashboard (After login)
    public static DASHBOARD_WAIVED_SUCCESS = 'DASHBOARD_WAIVED_SUCCESS';
    public static DASHBOARD_ENROLLED_SUCCESS = 'DASHBOARD_ENROLLED_SUCCESS';
    // My Account
    public static MY_ACCOUNT = 'MY_ACCOUNT';
    public static USER_LOGGED_IN = "USER_LOGGED_IN";
       // My Account - Login Info
    public static CHANGE_PD_SUCCESS = 'CHANGE_PD_SUCCESS';
    public static BULK_MAIL_SUCCESS = 'bulk_mail_success';
}
